import axios from "axios";
const jsonConfig = require("../../Config.json");

const insertIntoMyCandidate = async (profileId) => {
    let response = {}
    let payload={
        "candidateid":profileId
    }
       
    
    try {

        const insertIntoMyCandidateresponse = await axios.post(
            jsonConfig.apiUrl + "CreateMycandidate", payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );
        response = insertIntoMyCandidateresponse.data;

        return Promise.resolve(response)
    }
    catch (error) {
        //    console.error(error);
        return Promise.reject(error)
    }
}

export default insertIntoMyCandidate;